module.exports = __webpack_public_path__ + "fonts/remixicon.37f0891a.woff";